var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"colour-palette",style:(`backgroundColor: ${_vm.hexCode}`),attrs:{"data-qa":`colour swatch ${_vm.hexCode}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }